import * as yup from "yup";

export const trackingLnkSchema = yup.object().shape({
    tracking_link: yup.string().required().matches(
        /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
        'Enter correct url!'
    ).default("").label("Tracking link"),
});
